<template lang="pug">
  .component-translate-field
    .input-group
      slot
        .input-group-field(v-if="!showInput" )
          label {{label}}

      .input-group-label
        ModalReveal
          a(slot="trigger", title="Translate", @click="loadLang")
            mdi-icon( name="mdi-translate", :show-name="false" )
          label {{label}}
          div(v-html="value")
          TranslationEdit(:item="translations", :editor="editor", :skipDefaultLang="true", :editable="editable")
</template>

<script>
import ActionButton from "../../components/structure/ui/ActionButton";
import LoadingSpinner from "../../components/structure/LoadingSpinner";
import TransactionActionButtons from "../../components/structure/ui/actions/TransactionButtons.vue";
import TranslationButtons from "../../components/structure/ui/actions/TranslationButtons.vue";
import Editor from "../../components/structure/ui/Editor.vue";
import KeplerBackofficeSdk from "../../lib/kepler/backoffice";
import TranslationEdit from "./TranslationEdit.vue";
import ModalReveal from "../../components/structure/foundation/ModalReveal.vue";
import MdiIcon from "../../components/structure/ui/MdiIcon.vue";


export default {
  name: 'TranslateField',
  components: {
    MdiIcon,
    ModalReveal,
    TranslationEdit, Editor, TranslationButtons, TransactionActionButtons, LoadingSpinner, ActionButton
  },
  data() {
    return {
      translations: []
    }
  },
  created() {

  },
  methods: {
    loadLang() {
      KeplerBackofficeSdk.translations.list.overridable([this.group], this.field, (data) => {
        this.translations = data
      })
    }
  },
  computed: {},
  props: {
    group: {
      type: String
    },
    field: {
      type: String
    },
    label: {
      type: String
    },
    value: {
      type: String
    },
    showInput: {
      type: Boolean,
      default: false
    },
    editor: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: true
    },
  }
}
</script>

<style lang="sass" rel="stylesheet/sass">
.component-translate-field
  .input-group-label
    .componend-mdi-icon svg
      height: 1.6em

</style>



// WEBPACK FOOTER //
// TranslateField.vue?850b7b14